import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'

import { getToaster } from '@/store/getters'

import styles from './styles.scss'

const Toast = props => {
  const { position, isVisible, message, type } = props.toaster

  return (
    <React.Fragment>
      {
        isVisible &&
        // <div className={`
        //   ${styles['wrapper-toast']}
        //   ${styles[`wrapper-toast__type-${type}`]}
        //   ${styles[`wrapper-toast__position-${position}`]}
        // `}>{message}</div>
        <div className={`
          ba-toast ba-${type} 
          ${styles[`wrapper-toast`]} 
          ${styles[`wrapper-toast__position-${position}`]}
        `}>
          <div className={`ba-toast-alert`}>
              <div className='ba-left'>
                  <span className='ba-icon'></span>
                  <span className='ba-text'>{message}</span>
              </div>
          </div>
      </div>
      }
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const toaster = getToaster( state )
  return { toaster }
}

Toast.propTypes = {
  /** visible of toast */
  isVisible: propTypes.bool,
  /** type of toast  */
  type: propTypes.string,
  /** position of toast */
  position: propTypes.string,
  /** message of toast */
  message: propTypes.string
}

Toast.defaultProps = {
  isVisible: true,
  type: 'info',
  position: 'top-right',
  message: 'Message from notify'
}

export default connect( mapStateToProps )( Toast )



// WEBPACK FOOTER //
// ./src/components/Toast/index.js